module.exports = {
  sources: ($http, $stateParams) ->
    $http.get("/api/datatables/sources/?country=#{$stateParams.isoCode or ''}&sEcho=1&iDisplayStart=#{$stateParams.start or ''}" +
    "&iDisplayLength=25&sSearch=&category=#{$stateParams.category or ''}")

  country: ($http, $stateParams) ->
    $http.get("/api/v1/country/#{$stateParams.isoCode}/?expand_categories")
}
